// extracted by mini-css-extract-plugin
export var form = "_396e3e95c9027953063c65f6d446af45-css";